import { render, staticRenderFns } from "./IconSvgJpg.vue?vue&type=template&id=205ef2da&scoped=true&"
import script from "./IconSvgJpg.vue?vue&type=script&lang=js&"
export * from "./IconSvgJpg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ef2da",
  null
  
)

export default component.exports